/*
 *  I16DIMADOUCISSEURECSCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-19 12:44:30 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */
import { fetchCapaciteTraitementResine } from '@batical/data/src'
import { RCapaResineSchema_Type, I16DIMADOUCISSEURECS_State } from '@batical/types/src'

function I16DIMADOUCISSEURECS_docalcul(state: I16DIMADOUCISSEURECS_State) {
  state.invalidated = false
  if (state.in_thSouhaite === state.in_thEauVille) {
    state.res_cpcTraitementResine = 0
    //should be no 0
    state.res_traitementPrevoir = 0
    state.res_freqRegen = 0

    state.res_consoSalt = 0
    state.res_consoEauRenvoie = 0
    state.res_tauxSodiumEau = 0
  } else if (state.in_consommation === 0) {
    state.res_cpcTraitementResine = 0
    //should be no 0
    state.res_traitementPrevoir = 0
    state.res_freqRegen = 0

    state.res_consoSalt = 0
    state.res_consoEauRenvoie = 0
    state.res_tauxSodiumEau = 0
  } else {
    let selectedcpc: RCapaResineSchema_Type = fetchCapaciteTraitementResine(state.cpcTraitementLitreResine_uuid)
    //const res_quantiteSel = (state.in_thEauVille - state.in_thSouhaite) * 0.03 * 1000;
    state.res_cpcTraitementResine = state.in_resineSouhaite * selectedcpc.saltcapacity
    //should be no 0
    state.res_traitementPrevoir = ((state.in_thEauVille - state.in_thSouhaite) * state.in_consommation) / 1000
    state.res_freqRegen = state.res_cpcTraitementResine / state.res_traitementPrevoir
    if (state.res_freqRegen < 1) {
      state.res_freqRegen = state.res_freqRegen * 24
    }
    state.res_consoSalt = (selectedcpc.saltquantity * state.in_resineSouhaite) / 1000
    state.res_consoEauRenvoie = state.res_consoSalt / 0.333
    state.res_tauxSodiumEau = (state.in_thEauVille - state.in_thSouhaite) * 0.0046 * 1000
  }
  return state
}

export default I16DIMADOUCISSEURECS_docalcul
